import React, { FC } from 'react';
import Button from '../../../../../../ReactSharedScripts/components/Button';
import documentCardClasses from './documentCard.module.css';
import { DocumentCardProps } from 'modules/document/components/DocumentCard/types';
import RouteLink from '../../../../../../ReactSharedScripts/components/RouteLink';

const GenericDocumentLink: FC<
	React.PropsWithChildren<
		Pick<DocumentCardProps, 'url' | 'onNavigate'> & {
			styledButton?: boolean;
		}
	>
> = ({ styledButton, url, children, onNavigate }) => {
	if (typeof url === 'undefined') {
		return (
			<DocumentButton
				onNavigate={onNavigate}
				styledButton={styledButton}
			>
				{children}
			</DocumentButton>
		);
	}

	return (
		<DocumentLink
			url={url}
			styledButton={styledButton}
		>
			{children}
		</DocumentLink>
	);
};

const DocumentButton: FC<
	React.PropsWithChildren<
		Pick<DocumentCardProps, 'onNavigate'> & {
			styledButton?: boolean;
		}
	>
> = ({ onNavigate, styledButton, children }) => (
	<Button
		size='small'
		onClick={onNavigate}
		className={documentCardClasses.documentButton}
		reset={!styledButton}
	>
		{children}
	</Button>
);

const DocumentLink: FC<
	React.PropsWithChildren<
		Pick<DocumentCardProps, 'url'> & {
			styledButton?: boolean;
		}
	>
> = ({ styledButton, url, children }) => (
	<RouteLink
		size='small'
		href={url}
		target='_blank'
		hasColor={false}
		noUnderline
		styledButton={styledButton}
		className={documentCardClasses.documentButton}
	>
		{children}
	</RouteLink>
);

export { DocumentButton, DocumentLink, GenericDocumentLink };
